// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"6e325f54","54":"528a2dea","354":"af39579b","787":"6b69d54d"}[chunkId] + ".chunk.js";
};